module.exports = __webpack_public_path__ + "static/mdt-162ce33180758ac54731cdec0e1d4a25.svg";